
export const TraduzirNomeColunaPesquisaOrcamento = ({ nomeColuna }: { nomeColuna: string}) => {

    const mapColunasPesquisaOrcamento = {
        "DataPedido": "Data/Hora",
        "NumeroPedido": "Número do Pedido",
        "Filial": "Filial",
        "RazaoSocialCliente": "Cliente",
        "SituacaoMontagem": "Montagem",
        "SituacaoVenda": "Situação de Venda",
        "Vendedor": "Vendedor",
        "DataAtualizacao": "Data Histórico",
        "QtdeProdutos": "Quant. Produto(s)",
        "MarkupRealTotal": "% Markup",
        "PedidosDeCompra": "Pedido de Compra",
        "ValorPedido": "Valor do Pedido",
        "OrcamentosUnificados": "Orçamentos Unificados"
    }

    return nomeColuna in mapColunasPesquisaOrcamento ? mapColunasPesquisaOrcamento[nomeColuna] : null
} 